import {IAction, SET_IS_LOGGED_IN, SET_USER_NAME} from "../store";
import {getInitialAuthState} from "../store/get-initial-auth-state";

export interface AuthState {
    IsLoggedIn: boolean
    Username: string
}

export function authReducer(state: AuthState | undefined, action: IAction) {
    if(state === undefined) {  // Redux will inject from a preloadedState
        return getInitialAuthState()
    }

    switch (action.type) {
        case SET_IS_LOGGED_IN:
            return {
                ...state,
                IsLoggedIn: action.payload.isLoggedIn
            }
        case SET_USER_NAME:
            return {
                ...state,
                Username: action.payload.username
            }
        default:
            return state
    }
}